import * as Sentry from '@sentry/browser';
export default function sentry(dsn) {
  if (!dsn) {
    if (!document.location.href.startsWith('http://localhost')) {
      console.info('No sentry DSN given');
    }
  } else {
    let environment = document.location.host.match('www.placetel.') ? 'production' : 'staging';
    Sentry.init({
      allowUrls: [
        /staging\.placetel\.de/i,
        /www\.placetel\.de/i,
        /www\.placetel\.com/i,
      ],
      denyUrls:[
        /placetel\.de\/status/i,
        /status\.placetel\.de/i,
      ],
      dsn,
      environment,
      debug: environment !== 'production',
      ignoreErrors: [/^Warning: filemtime\(\)/, /^filemtime\(\)/, 'filemtime', 'Cannot read properties of undefined (reading \'parentNode\')']
    });
  }
}
